const DCP_ENV = require('dcp/common/dcp-env');
const { requireNative } = require('dcp/dcp-client/webpack-native-bridge');

Object.assign(exports, {
  async confirmPrompt(msg) {
    if (DCP_ENV.platform === 'nodejs') {
      const process = requireNative('process');

      console.log(msg);
      console.log('Press any key to continue...');
      process.stdin.setRawMode(true);
      await new Promise(resolve => process.stdin.once('data', resolve));
      process.stdin.setRawMode(false);

      return true;
    } else {
      return confirm(msg);
    }
  }
});
